import React, { useEffect, useState } from "react";
import { useAuth } from "../auth/FirebaseAuth.tsx";
import Space from "../layout/Space.tsx";
import PrimaryButton from "../buttons/PrimaryButton.tsx";
import { useSnackbar } from "notistack";
import { useAppContext } from "../config/AppContext.js";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken.js";
import {
  getArrayDocDataByID,
  getDocDataById,
  getDocDataByRef,
  getFlutterTimeFromSeconds,
  last_of_list,
  updateDocDataField,
} from "../models/DataFunctions.tsx";
import DropDownGPT03 from "../dropdown/DropDownGTP03.tsx";
import TextField2T from "../textfields/TextField2T.tsx";
import CheckBoxGrey from "../textfields/CheckBoxGrey.js";
import DatePickerGPT0 from "../textfields/DatePickerGPT0.tsx";
import SecondaryButton from "../buttons/SecondaryButton.tsx";
import Modal1 from "./Modal1.js";
import dayjs from "dayjs";
import sendRTBatiment from "../api/send/sendRTBatiment.js";
import { useNavigate } from "react-router-dom";
import { Divider, Spin } from "antd";
function RTBRE20Modal({
  userData,
  orgData,
  xml_id,
  onClose,
  setExtractingData,
  handleGenerateRTBAttestation,
}) {
  const navigate = useNavigate();
  const { currentUser, loading } = useAuth();

  const [rtb, setRtb] = useState(null);

  const [operator, setOperator] = useState(null);

  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;
  const [step, setStep] = useState(0);
  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };

  // Fetch user, org, clients, and article data
  const handleFetchData = async () => {
    if (orgData) {
      try {
        // Use config.atf.rtb_re2020 as the source of truth
        let rtb = orgData.config?.atf?.rtb_re2020
          ? { ...orgData.config.atf.rtb_re2020 }
          : {};

        setRtb(rtb);

        // Update state with fetched data
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };

  function checkFieldsFilled() {
    if (!date) {
      handleClickVariant("Veuillez renseigner une date", "error");
      return false;
    }

    if (
      !rtb.operation_fc_form_auteur_societe ||
      rtb.operation_fc_form_auteur_societe === ""
    ) {
      handleClickVariant("Veuillez renseigner le nom de l'entreprise", "error");
      return false;
    }
    if (
      !rtb.operation_fc_form_auteur_cp ||
      rtb.operation_fc_form_auteur_cp === ""
    ) {
      handleClickVariant("Veuillez renseigner le code postal", "error");
      return false;
    }
    if (
      !rtb.operation_fc_form_auteur_localite ||
      rtb.operation_fc_form_auteur_localite === ""
    ) {
      handleClickVariant("Veuillez renseigner la localité", "error");
      return false;
    }
    if (
      !rtb.operation_fc_form_auteur_adresse1 ||
      rtb.operation_fc_form_auteur_adresse1 === ""
    ) {
      handleClickVariant("Veuillez renseigner l'adresse", "error");
      return false;
    }
    if (
      !rtb.operation_fc_form_auteur_qualite ||
      rtb.operation_fc_form_auteur_qualite === ""
    ) {
      handleClickVariant("Veuillez renseigner la qualité", "error");
      return false;
    }
    if (
      !rtb.operation_fc_form_xml_depose ||
      rtb.operation_fc_form_xml_depose === ""
    ) {
      handleClickVariant(
        "Veuillez renseigner la fourniture du récapitulatif standardisé d'étude énergétique",
        "error"
      );
      return false;
    }
    if (
      !rtb.batiment_fc_form_perimetre_reseau_chaleur ||
      rtb.batiment_fc_form_perimetre_reseau_chaleur === ""
    ) {
      handleClickVariant(
        "Veuillez renseigner si le bâtiment est situé dans un périmètre de développement prioritaire d'un réseau de chaleur ou de froid classé",
        "error"
      );
      return false;
    }
    if (
      !rtb.batiment_fc_form_perimetre_reseau_chaleur_derogation ||
      rtb.batiment_fc_form_perimetre_reseau_chaleur_derogation === ""
    ) {
      handleClickVariant(
        "Veuillez renseigner si une dérogation à l’obligation de raccordement a-t-elle été obtenue",
        "error"
      );
      return false;
    }
    if (
      !rtb.batiment_fc_form_cep_nr_coherence ||
      rtb.batiment_fc_form_cep_nr_coherence === ""
    ) {
      handleClickVariant(
        "Veuillez renseigner la cohérence entre le récapitulatif standardisé d'étude énergétique et environnementale et le contrôle visuel sur site du nombre et du type de générateur",
        "error"
      );
      return false;
    }
    if (
      !rtb.batiment_fc_form_ic_construction_documents ||
      rtb.batiment_fc_form_ic_construction_documents === ""
    ) {
      handleClickVariant(
        "Veuillez renseigner la fourniture de documents justifiant des quantitatifs et des références des produits renseignés dans le récapitulatif standardisé d'étude énergétique et environnementale par le maître d'ouvrage",
        "error"
      );
      return false;
    }
    if (
      !rtb.batiment_fc_form_ic_construction_coherence1 ||
      rtb.batiment_fc_form_ic_construction_coherence1 === ""
    ) {
      handleClickVariant(
        "Veuillez renseigner la cohérence entre le récapitulatif standardisé d'étude énergétique et environnementale et le contrôle visuel sur site des systèmes de ventilation installés",
        "error"
      );
      return false;
    }
    if (
      !rtb.batiment_fc_form_ic_construction_coherence2 ||
      rtb.batiment_fc_form_ic_construction_coherence2 === ""
    ) {
      handleClickVariant(
        "Veuillez renseigner la cohérence entre le récapitulatif standardisé d'étude énergétique et environnementale et le contrôle visuel sur site des systèmes de ventilation installés",
        "error"
      );
      return false;
    }
    if (
      !rtb.batiment_fc_form_isolants_fourniture_documents ||
      rtb.batiment_fc_form_isolants_fourniture_documents === ""
    ) {
      handleClickVariant(
        "Veuillez renseigner la fourniture de documents justifiant des isolants posés par le maître d'ouvrage",
        "error"
      );
      return false;
    }
    if (
      !rtb.batiment_fc_form_isolants_coherence ||
      rtb.batiment_fc_form_isolants_coherence === ""
    ) {
      handleClickVariant(
        "Veuillez renseigner la cohérence entre le récapitulatif standardisé d'étude énergétique et environnementale et le document de justification des isolants posés par le maître d'ouvrage",
        "error"
      );
      return false;
    }
    if (
      !rtb.batiment_fc_form_isolants_respect_exigence ||
      rtb.batiment_fc_form_isolants_respect_exigence === ""
    ) {
      handleClickVariant(
        "Veuillez renseigner le respect de l'exigence U ≤ 0,36 W/(m².K) pour l'ensemble des isolants",
        "error"
      );
      return false;
    }
    if (
      !rtb.batiment_fc_form_protections_solaires_presence ||
      rtb.batiment_fc_form_protections_solaires_presence === ""
    ) {
      handleClickVariant(
        "Veuillez renseigner la présence de protections solaires",
        "error"
      );
      return false;
    }
    if (
      !rtb.batiment_fc_form_protections_solaires_coherence ||
      rtb.batiment_fc_form_protections_solaires_coherence === ""
    ) {
      handleClickVariant(
        "Veuillez renseigner la cohérence entre le récapitulatif standardisé d'étude énergétique et environnementale et le contrôle visuel sur site des protections solaires",
        "error"
      );
      return false;
    }
    if (
      !rtb.batiment_fc_form_protections_solaires_respect_exigence ||
      rtb.batiment_fc_form_protections_solaires_respect_exigence === ""
    ) {
      handleClickVariant(
        "Veuillez renseigner le respect de l'exigence U ≤ 0,36 W/(m².K) pour l'ensemble des isolants",
        "error"
      );
      return false;
    }
    if (
      !rtb.batiment_fc_form_permeabilite_air_igh ||
      rtb.batiment_fc_form_permeabilite_air_igh === ""
    ) {
      handleClickVariant(
        "Veuillez renseigner si le projet est un IGH ou la Sref > 3 000 m2",
        "error"
      );
      return false;
    }
    if (
      !rtb.batiment_fc_form_permeabilite_air_document_justification ||
      rtb.batiment_fc_form_permeabilite_air_document_justification === ""
    ) {
      handleClickVariant(
        "Veuillez renseigner le document de justification transmis par le maître d'ouvrage pour la perméabilité à l'air",
        "error"
      );
      return false;
    }
    if (
      !rtb.batiment_fc_form_permeabilite_air_fourniture_rapport ||
      rtb.batiment_fc_form_permeabilite_air_fourniture_rapport === ""
    ) {
      handleClickVariant(
        "Veuillez renseigner la fourniture du rapport de mesure pour la perméabilité à l'air",
        "error"
      );
      return false;
    }

    return true;
  }
  const [loadingOpen, setLoadingOpen] = useState(false);
  const [date, setDate] = useState(null);

  const handleLaunchRTB = async () => {
    try {
      if (!checkFieldsFilled()) {
        return;
      }
      let date_dayjs = date;
      if (date_dayjs === null) {
        handleClickVariant("Veuillez renseigner une date", "error");
        return;
      }

      let date_format = dayjs.unix(date_dayjs.seconds).format("YYYY-MM-DD");
      rtb.operation_fc_form_date_visite = date_format;
      setLoadingOpen(true);
      setExtractingData(true);
      await handleGenerateRTBAttestation("rtb_re2020", rtb);
      setExtractingData(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleSetOperator = (value, used_rtb) => {
    if (!value) return;
    setRtb({
      ...(used_rtb || rtb),
      operation_fc_form_auteur_nom: value.label,
    });
    setOperator(value.value);
  };

  useEffect(() => {
    if (orgData) {
      handleFetchData();
    }
  }, []);

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose(); // Close the modal if clicked on the backdrop
    }
  };

  if (loading || !currentUser || !orgData || !rtb) {
    return <Spin></Spin>;
  }

  return (
    <div
      className="w-screen h-screen flex flex-row items-center justify-center p-4"
      onClick={handleBackdropClick}
    >
      <div
        className="flex flex-col w-full  rounded-xl h-fit
     max-w-c1k 
      bg-white"
      >
        <div className="flex flex-col  overflow-y-auto  w-full">
          <div className="flex flex-col  w-full">
            <div className="flex flex-col p-6 gap-2">
              <div className="text-h1 text-black font-medium">
                Formulaire RE 2020
              </div>
              <div className="text-h3 text-shadow_50">
                Remplissez le formulaire pour configurer les champs par défaut
                de vos attestations RE 2020.
              </div>
              <div className="flex flex-row gap-2 items-center">
                <SecondaryButton
                  className="w-fit"
                  onClick={() => navigate("/rtb?section=form")}
                >
                  Configurer le formulaire par défaut
                </SecondaryButton>
                <SecondaryButton className="w-fit" onClick={() => onClose()}>
                  Annuler
                </SecondaryButton>
              </div>
              <div className="flex flex-col gap-1 max-h-c500 overflow-auto">
                <div className="text-h3 text-shadow_50 font-semibold">
                  Champs informations
                </div>
                <Space y={10} />
                <div className="flex flex-col gap-1 w-c500">
                  <TextField2T
                    label={"Opérateur"}
                    value={rtb.operation_fc_form_auteur_nom || ""}
                    field={"operation_fc_form_auteur_nom"}
                    onChange={(e) => {
                      setRtb({
                        ...rtb,
                        operation_fc_form_auteur_nom: e.target.value,
                      });
                    }}
                  ></TextField2T>

                  <TextField2T
                    label={"Nom entreprise"}
                    value={rtb.operation_fc_form_auteur_societe}
                    field={"operation_fc_form_auteur_societe"}
                    onChange={(e) =>
                      setRtb({
                        ...rtb,
                        operation_fc_form_auteur_societe: e.target.value,
                      })
                    }
                  ></TextField2T>
                  <TextField2T
                    label={"Code postal"}
                    value={rtb.operation_fc_form_auteur_cp}
                    field={"operation_fc_form_auteur_cp"}
                    onChange={(e) =>
                      setRtb({
                        ...rtb,
                        operation_fc_form_auteur_cp: e.target.value,
                      })
                    }
                  ></TextField2T>
                  <TextField2T
                    label={"Localité"}
                    value={rtb.operation_fc_form_auteur_localite}
                    field={"operation_fc_form_auteur_localite"}
                    onChange={(e) =>
                      setRtb({
                        ...rtb,
                        operation_fc_form_auteur_localite: e.target.value,
                      })
                    }
                  ></TextField2T>
                  <TextField2T
                    label={"Adresse"}
                    value={rtb.operation_fc_form_auteur_adresse1}
                    field={"operation_fc_form_auteur_adresse1"}
                    onChange={(e) =>
                      setRtb({
                        ...rtb,
                        operation_fc_form_auteur_adresse1: e.target.value,
                      })
                    }
                  ></TextField2T>
                  <div className="flex flex-col gap-2 ">
                    <div className="flex flex-row gap-4 ">
                      <DropDownGPT03
                        label={" En qualité de"}
                        items={[
                          {
                            value: "1",
                            label: "Organisme de contrôle technique",
                          },
                          {
                            value: "2",
                            label: "Architecte",
                          },
                          {
                            value: "3",
                            label: "Diagnostiqueur de performance énergétique",
                          },
                          {
                            value: "4",
                            label:
                              "Organisme ayant certifié la performance énergétique d’un nouveau bâtiment et ayant signé une convention avec le ministre chargé de la construction",
                          },
                          {
                            value: "5",
                            label: "Bureau d'étude agréé",
                          },
                        ]}
                        value={rtb.operation_fc_form_auteur_qualite?.value}
                        onChange={(value) =>
                          setRtb({
                            ...rtb,
                            operation_fc_form_auteur_qualite: {
                              ...rtb.operation_fc_form_auteur_qualite,
                              value: value.value.toString(),
                            },
                          })
                        }
                        className="w-c500"
                      />{" "}
                    </div>
                  </div>
                  <Space y={10} />

                  <DatePickerGPT0
                    seconds={date?.seconds}
                    onChange={(seconds) =>
                      setDate(getFlutterTimeFromSeconds(seconds))
                    }
                    disableAfterToday={true}
                    mandatory={true}
                  />

                  <Space y={10} />
                </div>
                <Space y={30} />
                <div className="text-h3 text-shadow_50 font-semibold">
                  Champs batiment
                </div>
                <Space y={10} />
                <div className="flex flex-col gap-2 w-fit">
                  <DropForm
                    label={
                      "Fourniture du récapitulatif standardisé d'étude énergétique"
                    }
                    value={rtb.operation_fc_form_xml_depose?.value}
                    onChange={(value) =>
                      setRtb({
                        ...rtb,
                        operation_fc_form_xml_depose: {
                          ...rtb.operation_fc_form_xml_depose,
                          value,
                        },
                      })
                    }
                  />

                  <DropForm
                    label={
                      "Le bâtiment est-il situé dans un périmètre de développement prioritaire d'un réseau de chaleur ou de froid classé ?"
                    }
                    value={rtb.batiment_fc_form_perimetre_reseau_chaleur?.value}
                    onChange={(value) =>
                      setRtb({
                        ...rtb,
                        batiment_fc_form_perimetre_reseau_chaleur: {
                          ...rtb.batiment_fc_form_perimetre_reseau_chaleur,
                          value,
                        },
                      })
                    }
                  />
                  <DropForm
                    label={
                      "Une dérogation à l’obligation de raccordement a-t-elle été obtenue ?"
                    }
                    value={
                      rtb.batiment_fc_form_perimetre_reseau_chaleur_derogation
                        ?.value
                    }
                    onChange={(value) =>
                      setRtb({
                        ...rtb,
                        batiment_fc_form_perimetre_reseau_chaleur_derogation: {
                          ...rtb.batiment_fc_form_perimetre_reseau_chaleur_derogation,
                          value,
                        },
                      })
                    }
                  />
                  <DropForm
                    label={
                      "Pour les générateurs de chaleur ou de froid utilisés pour le chauffage, la production d'eau chaude sanitaire et/ou le refroidissement des locaux la cohérence entre le récapitulatif standardisé d'étude énergétique et environnementale et le contrôle visuel sur site du nombre et du type de générateur"
                    }
                    value={rtb.batiment_fc_form_cep_nr_coherence?.value}
                    onChange={(value) =>
                      setRtb({
                        ...rtb,
                        batiment_fc_form_cep_nr_coherence: {
                          ...rtb.batiment_fc_form_cep_nr_coherence,
                          value,
                        },
                      })
                    }
                  />
                  <DropForm
                    label={
                      "Fourniture de documents justifiant des quantitatifs et des références des produits renseignés dans le récapitulatif standardisé d'étude énergétique et environnementale par le maître d'ouvrage"
                    }
                    value={
                      rtb.batiment_fc_form_ic_construction_documents?.value
                    }
                    onChange={(value) =>
                      setRtb({
                        ...rtb,
                        batiment_fc_form_ic_construction_documents: {
                          ...rtb.batiment_fc_form_ic_construction_documents,
                          value,
                        },
                      })
                    }
                  />
                  <DropForm
                    label={
                      "Pour les données d'entrée du calcul des indicateurs d'impact sur le changement climatique du bâtiment sélectionnées, les documents justifiant des quantitatifs et des références des produits renseignés dans le récapitulatif standardisé d'étude énergétique et environnementale et le récapitulatif standardisé d'étude énergétique et environnementale sont cohérents"
                    }
                    value={
                      rtb.batiment_fc_form_ic_construction_coherence1?.value
                    }
                    onChange={(value) =>
                      setRtb({
                        ...rtb,
                        batiment_fc_form_ic_construction_coherence1: {
                          ...rtb.batiment_fc_form_ic_construction_coherence1,
                          value,
                        },
                      })
                    }
                  />
                  <DropForm
                    label={
                      "Pour les données d'entrée du calcul des indicateurs d'impact sur le changement climatique du bâtiment sélectionnées, les documents justifiant des quantitatifs et des références des produits renseignés dans le récapitulatif standardisé d'étude énergétique et environnementale et le contrôle visuel sur site sont cohérents"
                    }
                    value={
                      rtb.batiment_fc_form_ic_construction_coherence2?.value
                    }
                    onChange={(value) =>
                      setRtb({
                        ...rtb,
                        batiment_fc_form_ic_construction_coherence2: {
                          ...rtb.batiment_fc_form_ic_construction_coherence2,
                          value,
                        },
                      })
                    }
                  />
                  <DropForm
                    label={
                      "Fourniture de documents de justification des isolants posés par le maître d'ouvrage"
                    }
                    value={
                      rtb.batiment_fc_form_isolants_fourniture_documents?.value
                    }
                    onChange={(value) =>
                      setRtb({
                        ...rtb,
                        batiment_fc_form_isolants_fourniture_documents: {
                          ...rtb.batiment_fc_form_isolants_fourniture_documents,
                          value,
                        },
                      })
                    }
                  />
                  <DropForm
                    label={
                      "Pour l'ensemble des isolants, cohérence entre le récapitulatif standardisé d'étude énergétique et environnementale et le document de justification des isolants posés par le maître d'ouvrage"
                    }
                    value={rtb.batiment_fc_form_isolants_coherence?.value}
                    onChange={(value) =>
                      setRtb({
                        ...rtb,
                        batiment_fc_form_isolants_coherence: {
                          ...rtb.batiment_fc_form_isolants_coherence,
                          value,
                        },
                      })
                    }
                  />
                  <DropForm
                    label={
                      "Pour l'ensemble des isolants, respect de l'exigence U ≤ 0,36 W/(m².K)"
                    }
                    value={
                      rtb.batiment_fc_form_isolants_respect_exigence?.value
                    }
                    onChange={(value) =>
                      setRtb({
                        ...rtb,
                        batiment_fc_form_isolants_respect_exigence: {
                          ...rtb.batiment_fc_form_isolants_respect_exigence,
                          value,
                        },
                      })
                    }
                  />
                  <DropForm
                    label={"Présence de protections solaires"}
                    value={
                      rtb.batiment_fc_form_protections_solaires_presence?.value
                    }
                    onChange={(value) =>
                      setRtb({
                        ...rtb,
                        batiment_fc_form_protections_solaires_presence: {
                          ...rtb.batiment_fc_form_protections_solaires_presence,
                          value,
                        },
                      })
                    }
                  />
                  <DropForm
                    label={
                      "Cohérence entre le récapitulatif standardisé d'étude énergétique et environnementale et le contrôle visuel sur site"
                    }
                    value={
                      rtb.batiment_fc_form_protections_solaires_coherence?.value
                    }
                    onChange={(value) =>
                      setRtb({
                        ...rtb,
                        batiment_fc_form_protections_solaires_coherence: {
                          ...rtb.batiment_fc_form_protections_solaires_coherence,
                          value,
                        },
                      })
                    }
                  />
                  <DropForm
                    label={
                      "À l'exception des baies des locaux à occupation passagère, les baies ont un facteur solaire inférieur ou égal au facteur solaire défini dans le tableau de l'article 24 de l'arrêté du 4 août 2021"
                    }
                    value={
                      rtb.batiment_fc_form_protections_solaires_respect_exigence
                        ?.value
                    }
                    onChange={(value) =>
                      setRtb({
                        ...rtb,
                        batiment_fc_form_protections_solaires_respect_exigence:
                          {
                            ...rtb.batiment_fc_form_protections_solaires_respect_exigence,
                            value,
                          },
                      })
                    }
                  />
                  <DropForm
                    label={
                      "Le projet est un IGH ou la Sref du projet > 3 000 m² ?"
                    }
                    value={rtb.batiment_fc_form_permeabilite_air_igh?.value}
                    onChange={(value) =>
                      setRtb({
                        ...rtb,
                        batiment_fc_form_permeabilite_air_igh: {
                          ...rtb.batiment_fc_form_permeabilite_air_igh,
                          value,
                        },
                      })
                    }
                  />
                  <DropForm
                    label={
                      "Document de justification transmis par le maître d'ouvrage"
                    }
                    items={[
                      { value: "1", label: "Mesure sur site" },
                      { value: "2", label: "Démarche qualité" },
                    ]}
                    value={
                      rtb
                        .batiment_fc_form_permeabilite_air_document_justification
                        ?.value
                    }
                    onChange={(value) =>
                      setRtb({
                        ...rtb,
                        batiment_fc_form_permeabilite_air_document_justification:
                          {
                            ...rtb.batiment_fc_form_permeabilite_air_document_justification,
                            value,
                          },
                      })
                    }
                  />
                  {rtb?.batiment_fc_form_permeabilite_air_document_justification
                    ?.value === "1" && (
                    <>
                      <DropForm
                        label={"Fourniture du rapport de mesure"}
                        value={
                          rtb
                            .batiment_fc_form_permeabilite_air_fourniture_rapport
                            ?.value
                        }
                        onChange={(value) =>
                          setRtb({
                            ...rtb,
                            batiment_fc_form_permeabilite_air_fourniture_rapport:
                              {
                                ...rtb.batiment_fc_form_permeabilite_air_fourniture_rapport,
                                value,
                              },
                          })
                        }
                      />
                      <DropForm
                        label={
                          "Le mesureur qui a signé le rapport de mesure figure sur la liste des mesureurs autorisés par le ministère chargé de la construction"
                        }
                        value={
                          rtb
                            .batiment_fc_form_permeabilite_air_mesureur_autorise
                            ?.value
                        }
                        onChange={(value) =>
                          setRtb({
                            ...rtb,
                            batiment_fc_form_permeabilite_air_mesureur_autorise:
                              {
                                ...rtb.batiment_fc_form_permeabilite_air_mesureur_autorise,
                                value,
                              },
                          })
                        }
                      />
                    </>
                  )}
                  {rtb?.batiment_fc_form_permeabilite_air_document_justification
                    ?.value === "2" && (
                    <>
                      <DropForm
                        label={
                          "Fourniture des documents certifiant la démarche qualité du maître d'ouvrage"
                        }
                        value={
                          rtb
                            .batiment_fc_form_permeabilite_air_qualite_documents
                            ?.value
                        }
                        onChange={(value) =>
                          setRtb({
                            ...rtb,
                            batiment_fc_form_permeabilite_air_qualite_documents:
                              {
                                ...rtb.batiment_fc_form_permeabilite_air_qualite_documents,
                                value,
                              },
                          })
                        }
                      />
                      <DropForm
                        label={
                          "Le certificateur qui a signé les documents la démarche qualité du maître d'ouvrage figure sur la liste des certificateurs autorisés par le ministère chargé de la construction"
                        }
                        value={
                          rtb
                            .batiment_fc_form_permeabilite_air_qualite_certificateur
                            ?.value
                        }
                        onChange={(value) =>
                          setRtb({
                            ...rtb,
                            batiment_fc_form_permeabilite_air_qualite_certificateur:
                              {
                                ...rtb.batiment_fc_form_permeabilite_air_qualite_certificateur,
                                value,
                              },
                          })
                        }
                      />
                    </>
                  )}
                  <DropForm
                    label={
                      "Cohérence entre le récapitulatif standardisé d'étude énergétique et environnementale et les documents justificatifs de l'exigence sur la perméabilité à l'air du bâtiment"
                    }
                    value={
                      rtb.batiment_fc_form_permeabilite_air_coherence?.value
                    }
                    onChange={(value) =>
                      setRtb({
                        ...rtb,
                        batiment_fc_form_permeabilite_air_coherence: {
                          ...rtb.batiment_fc_form_permeabilite_air_coherence,
                          value,
                        },
                      })
                    }
                  />
                  <DropForm
                    label={
                      "Cohérence entre le récapitulatif standardisé d'étude énergétique et environnementale et le contrôle visuel sur site des systèmes de ventilation installés"
                    }
                    value={rtb.batiment_fc_form_ventilation_coherence?.value}
                    onChange={(value) =>
                      setRtb({
                        ...rtb,
                        batiment_fc_form_ventilation_coherence: {
                          ...rtb.batiment_fc_form_ventilation_coherence,
                          value,
                        },
                      })
                    }
                  />
                  <DropForm
                    label={
                      "Un opérateur reconnu compétent par le ministre chargé de la construction a vérifié la conformité des systèmes de ventilation"
                    }
                    value={rtb.batiment_fc_form_ventilation_operateur?.value}
                    onChange={(value) =>
                      setRtb({
                        ...rtb,
                        batiment_fc_form_ventilation_operateur: {
                          ...rtb.batiment_fc_form_ventilation_operateur,
                          value,
                        },
                      })
                    }
                    items={[
                      { value: "1", label: "Oui" },
                      { value: "0", label: "Non" },
                      { value: "2", label: "Non concerné*" },
                    ]}
                  />
                  <DropForm
                    label={
                      "Conformité du système de ventilation attestée par le rapport de vérifications et de mesure fourni par le maître d'ouvrage"
                    }
                    value={rtb.batiment_fc_form_ventilation_conformite?.value}
                    onChange={(value) =>
                      setRtb({
                        ...rtb,
                        batiment_fc_form_ventilation_conformite: {
                          ...rtb.batiment_fc_form_ventilation_conformite,
                          value,
                        },
                      })
                    }
                  />
                </div>
              </div>{" "}
              <div className="flex flex-row justify-end gap-2 mt-4">
                <SecondaryButton className="w-fit" onClick={onClose}>
                  Annuler
                </SecondaryButton>
                <PrimaryButton
                  className="w-fit"
                  type="submit"
                  onClick={handleLaunchRTB}
                  disabled={date === null || loading}
                >
                  Lancer la génération
                </PrimaryButton>
              </div>
            </div>
          </div>{" "}
        </div>
      </div>
    </div>
  );
}

export default RTBRE20Modal;

const DropForm = ({
  label,
  value,
  onChange,
  items = [
    { value: "1", label: "Oui" },
    { value: "0", label: "Non" },
  ],
}) => {
  return (
    <div className="flex flex-col  ">
      <div className="flex flex-row gap-2 ">
        <div className="text-shadow_50 text-h3 w-c700">{label}</div>
        <DropDownGPT03
          label={"Choisir"}
          items={items}
          value={value}
          onChange={(value) => onChange(value)}
          className="w-c200"
        />
      </div>
      <div className="border-t-1 w-full my-4" />
    </div>
  );
};
